// extracted by mini-css-extract-plugin
module.exports = {"fontFamily":"FontFamilySelect_fontFamily__1cReH"};